// utils/classTimeUtils.js

export const WEEK_DAYS = [
  { label: "Mon", full: "Monday" },
  { label: "Tue", full: "Tuesday" },
  { label: "Wed", full: "Wednesday" },
  { label: "Thu", full: "Thursday" },
  { label: "Fri", full: "Friday" },
  { label: "Sat", full: "Saturday" },
  { label: "Sun", full: "Sunday" },
];

export const DAY_ORDER = [
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
  "Sun",
];

export const formatClassTime = (schedule = []) => {
  if (!Array.isArray(schedule) || schedule.length === 0) {
    return "Not Set";
  }

  const validGroups = schedule.filter(
    (group) =>
      group &&
      Array.isArray(group.days) &&
      group.days.length > 0 &&
      group.startTime &&
      group.endTime,
  );

  if (validGroups.length === 0) {
    return "Not Set";
  }

  return validGroups
    .map((group) => {
      const orderedDays = [...group.days].sort(
        (a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b),
      );

      return `${orderedDays.join(", ")}: ${group.startTime} - ${group.endTime}`;
    })
    .join("\n");
};

export const validateSchedule = (schedule = []) => {
  if (!schedule.length) {
    return "Please add at least one schedule.";
  }

  for (const group of schedule) {
    if (!group.days?.length) {
      return "Please select at least one day for every schedule.";
    }

    if (!group.startTime || !group.endTime) {
      return "Please select start and end time for every schedule.";
    }

    if (group.startTime >= group.endTime) {
      return "End time must be later than start time.";
    }
  }

  return null;
};